import { render, staticRenderFns } from "./SubmissionReviewModal.vue?vue&type=template&id=7d352d65&scoped=true"
import script from "./SubmissionReviewModal.vue?vue&type=script&lang=js"
export * from "./SubmissionReviewModal.vue?vue&type=script&lang=js"
import style0 from "./SubmissionReviewModal.vue?vue&type=style&index=0&id=7d352d65&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d352d65",
  null
  
)

export default component.exports